import $ from 'jquery';
import 'bootstrap';
import { initAllSliders} from "./utils/sliders";
import { initHeaderInfo} from "./utils/info-bar";
import { updateWeather, WEATHER_UPDATE_INTERVAL } from './utils/weather.js';
import './utils/search';
import { initCalendar} from "./utils/calendar";
import './utils/home-news';
import './utils/print';
import './utils/images';
import Inputmask from "inputmask";
import { Modal } from 'bootstrap';
import simpleParallax from 'simple-parallax-js';
import {initCookies} from "./utils/cookies";
import {track} from "./utils/observer";

window.$ = $;
window.jQuery = $;
window.Modal = Modal;

require('@fancyapps/fancybox');

initHeaderInfo();
initCookies();

$(function () {
    const mask = new Inputmask('+7 (999) 999-99-99');
    mask.mask(document.querySelectorAll('.maskedinput-phone'));

    // fancybox
    $('[data-fancybox="gallery"]').fancybox();

    let url = window.location.pathname;
    url = url.split('/');
    url = '/' + url[1];
    $('.nav-item a[href="' + url + '"]').addClass('active');

    $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
            $('.scrollup').removeClass('d-none');
        } else {
            $('.scrollup').addClass('d-none');
        }
    });

    $('.scrollup').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });

    if (window.innerWidth > 991) {
        $('.header__navbar-nav .dropdown').mouseover(function() {
            $(this).find('a[data-bs-toggle="dropdown"]').addClass('hover');
            $(this).find('.dropdown-menu').stop(true, true).delay(0).fadeIn(125);
        }).mouseout(function() {
            $(this).find('a[data-bs-toggle="dropdown"]').removeClass('hover');
            $(this).find('.dropdown-menu').stop(true, true).delay(0).fadeOut(50);
        })
    }


    $(document).on('click', 'a[data-scroll^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: ($($.attr(this, 'data-scroll')).offset().top - 100)
        }, 700);
    });

    if (document.querySelector('input[type=file]')) {
        let fileInputs = document.querySelectorAll('input[type=file]');
        fileInputs.forEach(function(input) {
            input.addEventListener('change', function() {

                let profilePicValue = input.value;
                let fileNameStart = profilePicValue.lastIndexOf('\\');
                profilePicValue = profilePicValue.substr(fileNameStart + 1);
                let profilePicLabelText = input.nextElementSibling;

                if (profilePicValue !== '') {
                    profilePicLabelText.innerHTML = 'Выбрать другой';
                    profilePicLabelText.classList.add('active');
                } else {
                    profilePicLabelText.innerHTML = 'Прикрепить файл';
                    profilePicLabelText.classList.remove('active');
                }
            });
        });
    }

    if (document.querySelector(".to-top")) {
        let toTop = document.querySelector(".to-top");

        window.onscroll = function() {
            scrollFunction()
        };

        function scrollFunction() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                toTop.classList.add('show');
            } else {
                toTop.classList.remove('show');
            }
        }

        function topFunction() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        toTop.addEventListener('click', function() {
            topFunction()
        })
    }
});

$(document).ready(function() {

    const animationDuration = 1;

    // Выбираем все элементы с классом 'svg-anim'
    const svgAnims = $('.svg-anim');

    // Функция для проверки элементов 'svg-anim' и выполнения анимации
    function checkSvgAnims() {
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();

        // Перебираем каждый элемент 'svg-anim'
        svgAnims.each(function(index, svgAnim) {
            const svgAnimTop = $(svgAnim).offset().top;

            // Проверяем, находится ли элемент в зоне видимости экрана
            if ((svgAnimTop >= scrollTop) && (svgAnimTop < (scrollTop + windowHeight))) {
                // Ваш код для анимации элемента 'svg-anim'
                const fillPaths = $(svgAnim).children();
                const filledPathsCount = $(svgAnim).data('filled-paths-count');

                fillPaths.each(function(pathIndex, path) {
                    const percentage = (pathIndex < filledPathsCount) ? 100 : 0;
                    const delay = animationDuration / filledPathsCount;

                    if (pathIndex < filledPathsCount) {
                        path.classList = "fill-animation";
                        $(path).css('animation-name', 'fillPath');
                        $(path).css('animation-duration', animationDuration + 's');
                        $(path).css('animation-delay', (pathIndex * delay) + 's');
                        $(path).css('--fill-percentage', percentage);
                    }
                });
            }
        });
    }

    // Вызываем функцию при загрузке страницы
    checkSvgAnims();

    // Вызываем функцию при прокрутке страницы
    $(window).scroll(checkSvgAnims);
});


$(function () {
    function updateQueryParam(key, value) {
        let url = new URL(window.location);
        url.searchParams.set(key, value);
        history.pushState({}, '', url);
    }

    function fetchQueryParam(key, value) {
        let url = new URLSearchParams(window.location.search);
        return url.get('page') || value;
    }

    function removeQueryParam(key) {
        let url = new URL(window.location);
        url.searchParams.delete(key);
        history.replaceState({}, '', url);
    }

    $(document).on('click', '.app-news-category', function (e) {
        e.preventDefault();
        const category = $(this).data('category');
        removeQueryParam('page');
        $.request('onNewsChangeCategory', {
            method: 'POST',
            loading: $.wn.stripeLoadIndicator,
            data: {
                category: category,
            },
        }).then((response) => {
            $('.app-news-category').removeClass('active');
            $(this).addClass('active');
            if (category !== 'news') {
                updateQueryParam('category', category);
            }
            else {
                removeQueryParam('category');
            }
            $('#appNewsList').html(response.appNewsList);
        });
    });

    $(document).on('click', '#appNewsListPaginationDynamic', function (e) {
        e.preventDefault();
        const category = $('.app-news-category.active').data('category');
        const page = parseInt(fetchQueryParam('page', 1));
        updateQueryParam('page', page + 1);
        $.request('onNewsChangeCategory', {
            method: 'POST',
            loading: $.wn.stripeLoadIndicator,
            data: {
                category: category,
                page: page + 1,
            },
        }).then((response) => {
            $('#appNewsList').append(response.appNewsList);
        });
    });

    $(document).on('click', '#appVideosListPaginationDynamic', function (e) {
        e.preventDefault();
        const page = parseInt(fetchQueryParam('page', 1));
        updateQueryParam('page', page + 1);
        $.request('onNewsLoadVideos', {
            method: 'POST',
            loading: $.wn.stripeLoadIndicator,
            data: {
                page: page + 1,
            },
        }).then((response) => {
            $('#appVideosList').append(response.appVideosList);
        });
    });

    $(document).on('click', '#appGalleriesListPaginationDynamic', function (e) {
        e.preventDefault();
        const page = parseInt(fetchQueryParam('page', 1));
        updateQueryParam('page', page + 1);
        $.request('onNewsLoadGalleries', {
            method: 'POST',
            loading: $.wn.stripeLoadIndicator,
            data: {
                page: page + 1,
            },
        }).then((response) => {
            $('#appGalleriesList').append(response.appGalleriesList);
        });
    })
});

//Добавляем классы объектам в зоне видимости (скролл)

function onEntry(entry) {
  entry.forEach(change => {
    if (change.isIntersecting) {
      change.target.classList.add('element-show');
    }
  });
}

let options = {
  threshold: [0.3] };
let observer = new IntersectionObserver(onEntry, options);
let elements = document.querySelectorAll('.element-animation');
let elementsImage = document.querySelectorAll('.element-animation-wrapper');

for (let elm of elements) {
  observer.observe(elm);
}

for (let elm of elementsImage) {
  observer.observe(elm);
}


//Параллакс
const image = document.getElementsByClassName('thumbnail');
new simpleParallax(image, {
    delay: 1.6,
    transition: 'cubic-bezier(0,0,0,1)',
    overflow: true,
    scale: 1.9
});
const block = document.getElementsByClassName('parallax-image');
new simpleParallax(block, {
    delay: .6,
    transition: 'cubic-bezier(0,0,0,1)'
});

document.addEventListener('DOMContentLoaded', () => {
    initAllSliders();

    updateWeather();
    setInterval(updateWeather, WEATHER_UPDATE_INTERVAL);

    initCalendar();

    track($('.app-trackable').get(), (el) => {
        const type = el.dataset.type;
        const id = el.dataset.id;
        if (!type || !id) return;

        $.request('onCountRecord', {
            method: 'POST',
            data: {
                type: type,
                id: id,
            }
        })
    });
});
